import actions from './actions';

const {
    SPL_STORE_SUMMARY_DATA_BEGIN, SPL_STORE_SUMMARY_DATA_SUCCESS, SPL_STORE_SUMMARY_DATA_ERR,
    GATE_MEETING_VIDEO_START_BEGIN, GATE_MEETING_VIDEO_START_SUCCESS, GATE_MEETING_VIDEO_START_ERR, GATE_MEETING_VIDEO_START_RESET,
    GATE_MEETING_VIDEO_CHUNK_BEGIN, GATE_MEETING_VIDEO_CHUNK_SUCCESS, GATE_MEETING_VIDEO_CHUNK_ERR, GATE_MEETING_VIDEO_CHUNK_RESET,
    GATE_MEETING_VIDEO_COMPLETE_BEGIN, GATE_MEETING_VIDEO_COMPLETE_SUCCESS, GATE_MEETING_VIDEO_COMPLETE_ERR, GATE_MEETING_VIDEO_COMPLETE_RESET,
    GATE_MEETING_SUBMIT_BEGIN, GATE_MEETING_SUBMIT_SUCCESS, GATE_MEETING_SUBMIT_ERR, GATE_MEETING_SUBMIT_RESET,
} = actions;

const initialState = { data: null, loading: false, error: null, };

// SPL Store Summary Data Reducers
export const splStoreSummaryReducers = (state = initialState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case SPL_STORE_SUMMARY_DATA_BEGIN:
            return {
                ...initialState,
                loading: true,
            };
        case SPL_STORE_SUMMARY_DATA_SUCCESS:
            return {
                ...initialState,
                data,
                error:null,
                loading: false,
            };
        case SPL_STORE_SUMMARY_DATA_ERR:
            return {
                ...initialState,
                error: err,
                data:null,
                loading: false,
            };

        default:
            return state;
    }
};

// Gate Meeting Video Start Reducers
export const gateMeetingVideoStartReducers = (state = initialState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case GATE_MEETING_VIDEO_START_BEGIN:
            return {
                ...initialState,
                loading: true,
            };
        case GATE_MEETING_VIDEO_START_SUCCESS:
            return {
                ...initialState,
                data,
                error:null,
                loading: false,
            };
        case GATE_MEETING_VIDEO_START_ERR:
            return {
                ...initialState,
                error: err,
                data:null,
                loading: false,
            };
        case GATE_MEETING_VIDEO_START_RESET:
            return initialState;
        default:
            return state;
    }
};

// Gate Meeting Video Chunk Reducers
export const gateMeetingVideoChunkReducers = (state = initialState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case GATE_MEETING_VIDEO_CHUNK_BEGIN:
            return {
                ...initialState,
                loading: true,
            };
        case GATE_MEETING_VIDEO_CHUNK_SUCCESS:
            return {
                ...initialState,
                data,
                error:null,
                loading: false,
            };
        case GATE_MEETING_VIDEO_CHUNK_ERR:
            return {
                ...initialState,
                error: err,
                data:null,
                loading: false,
            };
        case GATE_MEETING_VIDEO_CHUNK_RESET:
            return initialState;
        default:
            return state;
    }
};

// Gate Meeting Video Complete Reducers
export const gateMeetingVideoCompleteReducers = (state = initialState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case GATE_MEETING_VIDEO_COMPLETE_BEGIN:
            return {
                ...initialState,
                loading: true,
            };
        case GATE_MEETING_VIDEO_COMPLETE_SUCCESS:
            return {
                ...initialState,
                data,
                error:null,
                loading: false,
            };
        case GATE_MEETING_VIDEO_COMPLETE_ERR:
            return {
                ...initialState,
                error: err,
                data:null,
                loading: false,
            };
        case GATE_MEETING_VIDEO_COMPLETE_RESET:
            return initialState;
        default:
            return state;
    }
};

// Gate Meeting Submit Reducers
export const gateMeetingSubmitReducers = (state = initialState, action) => {
    const { type, data, err } = action;
    switch (type) {
        case GATE_MEETING_SUBMIT_BEGIN:
            return {
                ...initialState,
                loading: true,
            };
        case GATE_MEETING_SUBMIT_SUCCESS:
            return {
                ...initialState,
                data,
                error:null,
                loading: false,
            };
        case GATE_MEETING_SUBMIT_ERR:
            return {
                ...initialState,
                error: err,
                data:null,
                loading: false,
            };
        case GATE_MEETING_SUBMIT_RESET:
            return initialState;
        default:
            return state;
    }
};
